export const AssistantTarget = {
  QUANT_ROW_OPTIONS: "quant-row-options",
  QUANT_ACCOUNT_DELETE_DIALOG: "quant-account-delete-dialog",
  QUANT_ACCOUNT_VIEW: "quant-account-view",
  QUANT_ACCOUNT_DELETE: "quant-account-delete",
  QUANT_DASHBOARD: "quant-dashboard",
  QUANT_ACCOUNT_SELECT: "quant-account-select",
  QUANT_FRESHNESS: "quant-freshness",
  QUANT_INTERVAL: "quant-interval",
  QUANT_RANGE: "quant-range",
  QUANT_CHART: "quant-chart",
  QUANT_RISK: "quant-risk",

  QUANT_TRADING_PERFORMANCE_PAGE: "trading-performance-page",
  QUANT_TRADING_PERFORMANCE_ACCOUNTS: "trading-performance-accounts",
  QUANT_TRADING_PERFORMANCE_CREATE: "trading-performance-create",
  QUANT_TRADING_PERFORMANCE_EDITOR: "trading-performance-editor",
  QUANT_TRADING_PERFORMANCE_SAVE: "trading-performance-save",
  QUANT_TRADING_PERFORMANCE_EDIT: "trading-performance-edit",
  QUANT_TRADING_PERFORMANCE_COMPOSITION: "trading-performance-composition",

  EXCHANGE_ACCOUNT_PAGE: "exchange-account-page",
  EXCHANGE_ACCOUNT_CREATE: "exchange-account-create",
  EXCHANGE_ACCOUNT_EDIT_MENU: "exchange-account-edit-menu",
  EXCHANGE_ACCOUNT_EDIT: "exchange-account-edit",
  EXCHANGE_ACCOUNT_TYPE: "exchange-account-type",
  EXCHANGE_ACCOUNT_CREDENTIALS: "exchange-account-credentials",
  EXCHANGE_ACCOUNT_VERIFY: "exchange-account-verify",

  INFRASTRUCTURE_SYSTEM_TASK_TABLE: "infrastructure-system-task-table",
  INFRASTRUCTURE_SYSTEM_TASK_MENU_RUNNABLE:
    "infrastructure-system-task-menu-available",
  INFRASTRUCTURE_SYSTEM_TASK_MENU_ENABLED:
    "infrastructure-system-task-menu-enabled",
  INFRASTRUCTURE_SYSTEM_TASK_MENU_DISABLED:
    "infrastructure-system-task-menu-disabled",
  INFRASTRUCTURE_SYSTEM_TASK_PAGE: "infrastructure-system-task-page",
  INFRASTRUCTURE_SYSTEM_TASK_FILTERS: "infrastructure-system-task-filters",
  INFRASTRUCTURE_SYSTEM_TASK_ROW: "infrastructure-system-task-row",
  INFRASTRUCTURE_SYSTEM_TASK_MENU: "infrastructure-system-task-menu",
  INFRASTRUCTURE_SYSTEM_TASK_EDIT: "infrastructure-system-task-edit",
  INFRASTRUCTURE_SYSTEM_TASK_RUN: "infrastructure-system-task-run",
  INFRASTRUCTURE_SYSTEM_TASK_DISABLE: "infrastructure-system-task-disable",
  INFRASTRUCTURE_SYSTEM_TASK_ENABLE: "infrastructure-system-task-enable",
  INFRASTRUCTURE_SYSTEM_TASK_HISTORY: "infrastructure-system-task-history",
  INFRASTRUCTURE_SYSTEM_TASK_DEPENDENCIES:
    "infrastructure-system-task-dependencies",
  INFRASTRUCTURE_SYSTEM_TASK_SCHEDULE_MODAL:
    "infrastructure-system-task-schedule-modal",
  INFRASTRUCTURE_SYSTEM_TASK_ENABLED: "infrastructure-system-task-enabled",
  INFRASTRUCTURE_SYSTEM_TASK_REPEAT: "infrastructure-system-task-repeat",
  INFRASTRUCTURE_SYSTEM_TASK_VALUE: "infrastructure-system-task-value",
  INFRASTRUCTURE_SYSTEM_TASK_PREVIEW: "infrastructure-system-task-preview",
  INFRASTRUCTURE_SYSTEM_TASK_SAVE: "infrastructure-system-task-save",
  INFRASTRUCTURE_SYSTEM_TASK_HISTORY_MODAL:
    "infrastructure-system-task-history-modal",
  INFRASTRUCTURE_SYSTEM_TASK_RETRY: "infrastructure-system-task-retry",
  INFRASTRUCTURE_SYSTEM_TASK_DEPENDENCIES_MODAL:
    "infrastructure-system-task-dependencies-modal",
  INFRASTRUCTURE_SYSTEM_TASK_RUN_CONFIRM:
    "infrastructure-system-task-run-confirm",
  INFRASTRUCTURE_SYSTEM_TASK_DISABLE_CONFIRM:
    "infrastructure-system-task-disable-confirm",
  INFRASTRUCTURE_SYSTEM_TASK_ENABLE_CONFIRM:
    "infrastructure-system-task-enable-confirm",
  INFRASTRUCTURE_SYSTEM_TASK_CONFIRM_CANCEL:
    "infrastructure-system-task-confirm-cancel",
  TASK_DELETE_OPTIONS: "task-delete-options",
  TASK_DELETE_NAME: "task-delete-name",
  RECURRING_DELETE_OPTIONS: "recurring-delete-options",
  RECURRING_DELETE_NAME: "recurring-delete-name",
  REMINDER_DELETE_OPTIONS: "reminder-delete-options",
  REMINDER_DELETE_NAME: "reminder-delete-name",

  HR_CAPITAL_FORMATION_DISTRIBUTION_DOCUMENT_REMOVE:
    "hr-capital-formation-distribution-document-remove",
  HR_VENTURE_DISTRIBUTION_DOCUMENT_REMOVE:
    "hr-venture-distribution-document-remove",
  HR_QUANT_DISTRIBUTION_DOCUMENT_REMOVE:
    "hr-quant-distribution-document-remove",
  HR_EMPLOYEE_CHECKLIST_REMOVE: "hr-employee-checklist-remove",
  HR_EMPLOYEE_DOCUMENT_REMOVE: "hr-employee-document-remove",
  HR_EMPLOYEE_LEAVE_SECTION: "hr-employee-leave-section",
  HR_EMPLOYEE_COMPENSATION_SECTION: "hr-employee-compensation-section",
  HR_EMPLOYEE_LEAVE_YEAR: "hr-employee-leave-year",
  HR_EMPLOYEE_LEAVE_FORM: "hr-employee-leave-form",
  HR_EMPLOYEE_LEAVE_SAVE: "hr-employee-leave-save",

  HR_QUANT_DISTRIBUTION_FILTERS: "hr-quant-distribution-filters",
  HR_EMPLOYEE_LEAVE_FILTERS: "hr-employee-leave-filters",
  HR_QUANT_PERFORMANCE_FILTERS: "hr-quant-performance-filters",
  HR_HOLIDAY_CALENDAR_FILTERS: "hr-holiday-calendar-filters",
  HR_VENTURE_DISTRIBUTION_FILTERS: "hr-venture-distribution-filters",
  HR_VENTURE_PERFORMANCE_FILTERS: "hr-venture-performance-filters",
  HR_EMPLOYEE_FILTERS: "hr-employee-filters",
  HR_FINANCIAL_REPORT_FILTERS: "hr-financial-report-filters",
  HR_VENTURE_POINTS_FILTERS: "hr-venture-points-filters",
  HR_EMPLOYEE_DISCARD: "hr-employee-discard",
  HR_EMPLOYEE_DRAFT: "hr-employee-draft",
  HR_EMPLOYEE_CLOSE: "hr-employee-close",
  HR_HOLIDAY_CALENDAR_DISCARD: "hr-holiday-calendar-discard",
  HR_HOLIDAY_CALENDAR_DRAFT: "hr-holiday-calendar-draft",
  HR_HOLIDAY_CALENDAR_CLOSE: "hr-holiday-calendar-close",
  HR_VENTURE_POINTS_DISCARD: "hr-venture-points-discard",
  HR_VENTURE_POINTS_DRAFT: "hr-venture-points-draft",
  HR_VENTURE_PERFORMANCE_DISCARD: "hr-venture-performance-discard",
  HR_VENTURE_PERFORMANCE_DRAFT: "hr-venture-performance-draft",
  HR_CAPITAL_FORMATION_TIER_DISCARD: "hr-capital-formation-tier-discard",
  HR_CAPITAL_FORMATION_TIER_DRAFT: "hr-capital-formation-tier-draft",
  HR_EMPLOYEE_DOCUMENTS: "hr-employee-documents",
  HR_EMPLOYEE_DOCUMENT_LIST: "hr-employee-document-list",
  HR_EMPLOYEE_COMPENSATION_CANCEL: "hr-employee-compensation-cancel",

  HR_FINANCIAL_REPORT_PAGE: "hr-financial-report-page",
  HR_FINANCIAL_REPORT_ROW: "hr-financial-report-row",
  HR_QUANT_FUND_TIER_PAGE: "hr-quant-fund-tier-page",
  HR_QUANT_FUND_TIER_ROW: "hr-quant-fund-tier-row",
  HR_QUANT_FUND_TIER_SECTION: "hr-quant-fund-tier-section",
  HR_QUANT_FUND_TIER_FORM: "hr-quant-fund-tier-form",
  HR_QUANT_FUND_TIER_SUBMIT: "hr-quant-fund-tier-submit",
  HR_QUANT_FUND_TIER_CANCEL: "hr-quant-fund-tier-cancel",
  HR_QUANT_FUND_TIER_UPDATE_CONFIRM: "hr-quant-fund-tier-update-confirm",
  HR_QUANT_FUND_TIER_EDIT: "hr-quant-fund-tier-edit",
  HR_QUANT_FUND_TIER_DELETE: "hr-quant-fund-tier-delete",
  HR_QUANT_FUND_TIER_DELETE_CONFIRM: "hr-quant-fund-tier-delete-confirm",
  HR_QUANT_FUND_TIER_OPTIONS: "hr-quant-fund-tier-options",
  HR_QUANT_POINTS_PAGE: "hr-quant-points-page",
  HR_QUANT_POINTS_ROW: "hr-quant-points-row",
  HR_QUANT_PERFORMANCE_PAGE: "hr-quant-performance-page",
  HR_QUANT_PERFORMANCE_EDIT: "hr-quant-performance-edit",
  HR_QUANT_PERFORMANCE_DELETE: "hr-quant-performance-delete",
  HR_QUANT_PERFORMANCE_DELETE_CONFIRM: "hr-quant-performance-delete-confirm",
  HR_QUANT_PERFORMANCE_DELETE_NAME: "hr-quant-performance-delete-name",
  HR_QUANT_PERFORMANCE_OPTIONS: "hr-quant-performance-options",
  HR_QUANT_DISTRIBUTION_PAGE: "hr-quant-distribution-page",
  HR_QUANT_DISTRIBUTION_CLOSE: "hr-quant-distribution-close",
  HR_QUANT_DISTRIBUTION_DETAILS: "hr-quant-distribution-details",
  HR_QUANT_DISTRIBUTION_FORM: "hr-quant-distribution-form",
  HR_QUANT_DISTRIBUTION_SUBMIT: "hr-quant-distribution-submit",
  HR_QUANT_DISTRIBUTION_DOCUMENTS: "hr-quant-distribution-documents",
  HR_QUANT_DISTRIBUTION_HISTORY_ROW: "hr-quant-distribution-history-row",
  HR_QUANT_DISTRIBUTION_HISTORY_SECTION:
    "hr-quant-distribution-history-section",
  HR_QUANT_DISTRIBUTION_HISTORY_FORM: "hr-quant-distribution-history-form",
  HR_QUANT_DISTRIBUTION_HISTORY_SUBMIT: "hr-quant-distribution-history-submit",
  HR_QUANT_DISTRIBUTION_HISTORY_CANCEL: "hr-quant-distribution-history-cancel",
  HR_QUANT_DISTRIBUTION_HISTORY_UPDATE_CONFIRM:
    "hr-quant-distribution-history-update-confirm",
  HR_QUANT_DISTRIBUTION_ROW: "hr-quant-distribution-row",
  HR_QUANT_DISTRIBUTION_HISTORY_EDIT: "hr-quant-distribution-history-edit",
  HR_QUANT_DISTRIBUTION_HISTORY_DELETE: "hr-quant-distribution-history-delete",
  HR_QUANT_DISTRIBUTION_VIEW: "hr-quant-distribution-view",
  HR_QUANT_DISTRIBUTION_EDIT: "hr-quant-distribution-edit",
  HR_QUANT_DISTRIBUTION_HISTORY_DELETE_CONFIRM:
    "hr-quant-distribution-history-delete-confirm",
  HR_QUANT_DISTRIBUTION_HISTORY_OPTIONS:
    "hr-quant-distribution-history-options",
  HR_QUANT_DISTRIBUTION_OPTIONS: "hr-quant-distribution-options",
  HR_VENTURE_POINTS_PAGE: "hr-venture-points-page",
  HR_VENTURE_POINTS_CREATE: "hr-venture-points-create",
  HR_VENTURE_POINTS_ROW: "hr-venture-points-row",
  HR_VENTURE_POINTS_CLOSE: "hr-venture-points-close",
  HR_VENTURE_POINTS_DETAILS: "hr-venture-points-details",
  HR_VENTURE_POINTS_FORM: "hr-venture-points-form",
  HR_VENTURE_POINTS_SUBMIT: "hr-venture-points-submit",
  HR_VENTURE_POINTS_CONTINUE: "hr-venture-points-continue",
  HR_VENTURE_POINTS_HISTORY_ROW: "hr-venture-points-history-row",
  HR_VENTURE_POINTS_HISTORY_SECTION: "hr-venture-points-history-section",
  HR_VENTURE_POINTS_HISTORY_FORM: "hr-venture-points-history-form",
  HR_VENTURE_POINTS_HISTORY_SUBMIT: "hr-venture-points-history-submit",
  HR_VENTURE_POINTS_HISTORY_CANCEL: "hr-venture-points-history-cancel",
  HR_VENTURE_POINTS_HISTORY_UPDATE_CONFIRM:
    "hr-venture-points-history-update-confirm",
  HR_VENTURE_POINTS_VIEW: "hr-venture-points-view",
  HR_VENTURE_POINTS_EDIT: "hr-venture-points-edit",
  HR_VENTURE_POINTS_DELETE: "hr-venture-points-delete",
  HR_VENTURE_POINTS_HISTORY_EDIT: "hr-venture-points-history-edit",
  HR_VENTURE_POINTS_HISTORY_DELETE: "hr-venture-points-history-delete",
  HR_VENTURE_POINTS_DELETE_CONFIRM: "hr-venture-points-delete-confirm",
  HR_VENTURE_POINTS_DELETE_NAME: "hr-venture-points-delete-name",
  HR_VENTURE_POINTS_HISTORY_DELETE_CONFIRM:
    "hr-venture-points-history-delete-confirm",
  HR_VENTURE_POINTS_OPTIONS: "hr-venture-points-options",
  HR_VENTURE_POINTS_HISTORY_OPTIONS: "hr-venture-points-history-options",
  HR_VENTURE_PERFORMANCE_PAGE: "hr-venture-performance-page",
  HR_VENTURE_PERFORMANCE_ROW: "hr-venture-performance-row",
  HR_VENTURE_PERFORMANCE_CREATE: "hr-venture-performance-create",
  HR_VENTURE_PERFORMANCE_CLOSE: "hr-venture-performance-close",
  HR_VENTURE_PERFORMANCE_DETAILS: "hr-venture-performance-details",
  HR_VENTURE_PERFORMANCE_FORM: "hr-venture-performance-form",
  HR_VENTURE_PERFORMANCE_SUBMIT: "hr-venture-performance-submit",
  HR_VENTURE_PERFORMANCE_CONTINUE: "hr-venture-performance-continue",
  HR_VENTURE_PERFORMANCE_VIEW: "hr-venture-performance-view",
  HR_VENTURE_PERFORMANCE_EDIT: "hr-venture-performance-edit",
  HR_VENTURE_PERFORMANCE_DELETE: "hr-venture-performance-delete",
  HR_VENTURE_PERFORMANCE_DELETE_CONFIRM:
    "hr-venture-performance-delete-confirm",
  HR_VENTURE_PERFORMANCE_DELETE_NAME: "hr-venture-performance-delete-name",
  HR_VENTURE_PERFORMANCE_OPTIONS: "hr-venture-performance-options",
  HR_VENTURE_DISTRIBUTION_PAGE: "hr-venture-distribution-page",
  HR_VENTURE_DISTRIBUTION_CLOSE: "hr-venture-distribution-close",
  HR_VENTURE_DISTRIBUTION_DETAILS: "hr-venture-distribution-details",
  HR_VENTURE_DISTRIBUTION_FORM: "hr-venture-distribution-form",
  HR_VENTURE_DISTRIBUTION_SUBMIT: "hr-venture-distribution-submit",
  HR_VENTURE_DISTRIBUTION_DOCUMENTS: "hr-venture-distribution-documents",
  HR_VENTURE_DISTRIBUTION_HISTORY_ROW: "hr-venture-distribution-history-row",
  HR_VENTURE_DISTRIBUTION_HISTORY_SECTION:
    "hr-venture-distribution-history-section",
  HR_VENTURE_DISTRIBUTION_HISTORY_FORM: "hr-venture-distribution-history-form",
  HR_VENTURE_DISTRIBUTION_HISTORY_SUBMIT:
    "hr-venture-distribution-history-submit",
  HR_VENTURE_DISTRIBUTION_HISTORY_CANCEL:
    "hr-venture-distribution-history-cancel",
  HR_VENTURE_DISTRIBUTION_HISTORY_UPDATE_CONFIRM:
    "hr-venture-distribution-history-update-confirm",
  HR_VENTURE_DISTRIBUTION_ROW: "hr-venture-distribution-row",
  HR_VENTURE_DISTRIBUTION_HISTORY_EDIT: "hr-venture-distribution-history-edit",
  HR_VENTURE_DISTRIBUTION_HISTORY_DELETE:
    "hr-venture-distribution-history-delete",
  HR_VENTURE_DISTRIBUTION_VIEW: "hr-venture-distribution-view",
  HR_VENTURE_DISTRIBUTION_EDIT: "hr-venture-distribution-edit",
  HR_VENTURE_DISTRIBUTION_HISTORY_DELETE_CONFIRM:
    "hr-venture-distribution-history-delete-confirm",
  HR_VENTURE_DISTRIBUTION_HISTORY_OPTIONS:
    "hr-venture-distribution-history-options",
  HR_VENTURE_DISTRIBUTION_OPTIONS: "hr-venture-distribution-options",
  HR_CAPITAL_FORMATION_TIER_PAGE: "hr-capital-formation-tier-page",
  HR_CAPITAL_FORMATION_TIER_ROW: "hr-capital-formation-tier-row",
  HR_CAPITAL_FORMATION_TIER_CLOSE: "hr-capital-formation-tier-close",
  HR_CAPITAL_FORMATION_TIER_DETAILS: "hr-capital-formation-tier-details",
  HR_CAPITAL_FORMATION_TIER_FORM: "hr-capital-formation-tier-form",
  HR_CAPITAL_FORMATION_TIER_SUBMIT: "hr-capital-formation-tier-submit",
  HR_CAPITAL_FORMATION_TIER_CONTINUE: "hr-capital-formation-tier-continue",
  HR_CAPITAL_FORMATION_TIER_CREATE: "hr-capital-formation-tier-create",
  HR_CAPITAL_FORMATION_TIER_VIEW: "hr-capital-formation-tier-view",
  HR_CAPITAL_FORMATION_TIER_EDIT: "hr-capital-formation-tier-edit",
  HR_CAPITAL_FORMATION_TIER_DELETE: "hr-capital-formation-tier-delete",
  HR_CAPITAL_FORMATION_TIER_DELETE_CONFIRM:
    "hr-capital-formation-tier-delete-confirm",
  HR_CAPITAL_FORMATION_TIER_DELETE_NAME:
    "hr-capital-formation-tier-delete-name",
  HR_CAPITAL_FORMATION_TIER_OPTIONS: "hr-capital-formation-tier-options",
  HR_CAPITAL_FORMATION_DISTRIBUTION_PAGE:
    "hr-capital-formation-distribution-page",
  HR_CAPITAL_FORMATION_DISTRIBUTION_CLOSE:
    "hr-capital-formation-distribution-close",
  HR_CAPITAL_FORMATION_DISTRIBUTION_DETAILS:
    "hr-capital-formation-distribution-details",
  HR_CAPITAL_FORMATION_DISTRIBUTION_FORM:
    "hr-capital-formation-distribution-form",
  HR_CAPITAL_FORMATION_DISTRIBUTION_SUBMIT:
    "hr-capital-formation-distribution-submit",
  HR_CAPITAL_FORMATION_DISTRIBUTION_DOCUMENTS:
    "hr-capital-formation-distribution-documents",
  HR_CAPITAL_FORMATION_DISTRIBUTION_HISTORY_ROW:
    "hr-capital-formation-distribution-history-row",
  HR_CAPITAL_FORMATION_DISTRIBUTION_HISTORY_SECTION:
    "hr-capital-formation-distribution-history-section",
  HR_CAPITAL_FORMATION_DISTRIBUTION_HISTORY_FORM:
    "hr-capital-formation-distribution-history-form",
  HR_CAPITAL_FORMATION_DISTRIBUTION_HISTORY_SUBMIT:
    "hr-capital-formation-distribution-history-submit",
  HR_CAPITAL_FORMATION_DISTRIBUTION_HISTORY_CANCEL:
    "hr-capital-formation-distribution-history-cancel",
  HR_CAPITAL_FORMATION_DISTRIBUTION_HISTORY_UPDATE_CONFIRM:
    "hr-capital-formation-distribution-history-update-confirm",
  HR_CAPITAL_FORMATION_DISTRIBUTION_TRACKING_ROW:
    "hr-capital-formation-distribution-tracking-row",
  HR_CAPITAL_FORMATION_DISTRIBUTION_ADJUSTMENT_ROW:
    "hr-capital-formation-distribution-adjustment-row",
  HR_CAPITAL_FORMATION_DISTRIBUTION_ROW:
    "hr-capital-formation-distribution-row",
  HR_CAPITAL_FORMATION_DISTRIBUTION_HISTORY_EDIT:
    "hr-capital-formation-distribution-history-edit",
  HR_CAPITAL_FORMATION_DISTRIBUTION_HISTORY_DELETE:
    "hr-capital-formation-distribution-history-delete",
  HR_CAPITAL_FORMATION_DISTRIBUTION_ADJUSTMENT_EDIT:
    "hr-capital-formation-distribution-adjustment-edit",
  HR_CAPITAL_FORMATION_DISTRIBUTION_ADJUSTMENT_DELETE:
    "hr-capital-formation-distribution-adjustment-delete",
  HR_CAPITAL_FORMATION_DISTRIBUTION_VIEW:
    "hr-capital-formation-distribution-view",
  HR_CAPITAL_FORMATION_DISTRIBUTION_EDIT:
    "hr-capital-formation-distribution-edit",
  HR_CAPITAL_FORMATION_DISTRIBUTION_HISTORY_DELETE_CONFIRM:
    "hr-capital-formation-distribution-history-delete-confirm",
  HR_CAPITAL_FORMATION_DISTRIBUTION_HISTORY_OPTIONS:
    "hr-capital-formation-distribution-history-options",
  HR_CAPITAL_FORMATION_DISTRIBUTION_ADJUSTMENT_OPTIONS:
    "hr-capital-formation-distribution-adjustment-options",
  HR_CAPITAL_FORMATION_DISTRIBUTION_OPTIONS:
    "hr-capital-formation-distribution-options",
  HR_QUANT_POINTS_YEAR: "hr-quant-points-year",
  HR_QUANT_POINTS_FORM: "hr-quant-points-form",
  HR_QUANT_POINTS_SUBMIT: "hr-quant-points-submit",
  HR_QUANT_POINTS_CANCEL: "hr-quant-points-cancel",
  HR_QUANT_POINTS_UPDATE_CONFIRM: "hr-quant-points-update-confirm",
  HR_QUANT_FUND_TIER_DUPLICATE: "hr-quant-fund-tier-duplicate",
  HR_QUANT_FUND_TIER_SOURCE_FUND: "hr-quant-fund-tier-source-fund",
  HR_QUANT_PERFORMANCE_TABLE: "hr-quant-performance-table",
  HR_QUANT_PERFORMANCE_CREATE: "hr-quant-performance-create",
  HR_QUANT_PERFORMANCE_FORM: "hr-quant-performance-form",
  HR_QUANT_PERFORMANCE_SUBMIT: "hr-quant-performance-submit",
  HR_QUANT_PERFORMANCE_CANCEL: "hr-quant-performance-cancel",
  HR_QUANT_PERFORMANCE_SECTION: "hr-quant-performance-section",
  HR_QUANT_PERFORMANCE_STATISTICS: "hr-quant-performance-statistics",
  HR_FINANCIAL_REPORT_GROUPING: "hr-financial-report-grouping",
  HR_FINANCIAL_REPORT_CHART: "hr-financial-report-chart",
  HR_FINANCIAL_REPORT_TABLE: "hr-financial-report-table",
  HR_CAPITAL_FORMATION_DISTRIBUTION_ADJUSTMENT_SECTION:
    "hr-capital-formation-distribution-adjustment-section",
  HR_CAPITAL_FORMATION_DISTRIBUTION_ADJUSTMENT_DELETE_CONFIRM:
    "hr-capital-formation-distribution-adjustment-delete-confirm",
  HR_CAPITAL_FORMATION_DISTRIBUTION_ADJUSTMENT_FORM:
    "hr-capital-formation-distribution-adjustment-form",
  HR_CAPITAL_FORMATION_DISTRIBUTION_ADJUSTMENT_SUBMIT:
    "hr-capital-formation-distribution-adjustment-submit",
  HR_CAPITAL_FORMATION_DISTRIBUTION_ADJUSTMENT_CANCEL:
    "hr-capital-formation-distribution-adjustment-cancel",
  HR_CAPITAL_FORMATION_DISTRIBUTION_TRACKING_SECTION:
    "hr-capital-formation-distribution-tracking-section",

  TASK_LIST_FILTERS: "task-list-filters",
  TASK_LIST_ROW: "task-list-row",
  TASK_LIST_CREATE: "task-list-create",
  RECURRING_LIST_FILTERS: "recurring-list-filters",
  RECURRING_LIST_ROW: "recurring-list-row",
  RECURRING_LIST_CREATE: "recurring-list-create",
  REMINDER_LIST_FILTERS: "reminder-list-filters",
  REMINDER_LIST_ROW: "reminder-list-row",
  REMINDER_LIST_CREATE: "reminder-list-create",
  REPORT_FILTERS: "report-filters",
  REPORT_SUMMARY: "report-summary",
  REPORT_BREAKDOWN: "report-breakdown",
  PERMISSION_ROLES_TAB: "permission-roles-tab",
  PERMISSION_USERS_TAB: "permission-users-tab",
  PERMISSION_SOURCES_TAB: "permission-sources-tab",
  PERMISSION_ROLE_ROW: "permission-role-row",
  PERMISSION_USER_ROW: "permission-user-row",
  PERMISSION_CREATE_ROLE: "permission-create-role",
  PERMISSION_CREATE_FORM: "permission-create-form",
  PERMISSION_CREATE_SAVE: "permission-create-save",
  PERMISSION_ROLE_DETAILS: "permission-role-details",
  PERMISSION_ROLE_FIELDS: "permission-role-fields",
  PERMISSION_ROLE_SAVE: "permission-role-save",
  PERMISSION_ROLE_DELETE: "permission-role-delete",
  PERMISSION_DELETE_NAME: "permission-delete-name",
  PERMISSION_DELETE_CONFIRM: "permission-delete-confirm",
  PERMISSION_USER_DETAILS: "permission-user-details",
  PERMISSION_USER_ROLES: "permission-user-roles",
  PERMISSION_USER_EXCEPTIONS: "permission-user-exceptions",
  PERMISSION_USER_SAVE: "permission-user-save",
  PERMISSION_USER_CONFIRM: "permission-user-confirm",
  PERMISSION_USER_CONFIRM_SAVE: "permission-user-confirm-save",
  PERMISSION_SOURCES: "permission-sources",
  PERMISSION_CACHE_USER: "permission-cache-user",
  PERMISSION_CACHE_ALL: "permission-cache-all",
  NOTIFICATION_FILTERS: "notification-filters",
  NOTIFICATION_ROW: "notification-row",
  NOTIFICATION_DETAILS: "notification-details",
  NOTIFICATION_OPTIONS: "notification-options",
  NOTIFICATION_EDIT: "notification-edit",
  NOTIFICATION_CHANNELS: "notification-channels",
  NOTIFICATION_TELEGRAM_CHANNEL: "notification-telegram-channel",
  NOTIFICATION_RECIPIENTS: "notification-recipients",
  NOTIFICATION_TELEGRAM: "notification-telegram",
  NOTIFICATION_TELEGRAM_INPUT: "notification-telegram-input",
  NOTIFICATION_TELEGRAM_ADD: "notification-telegram-add",
  NOTIFICATION_TELEGRAM_REFRESH: "notification-telegram-refresh",
  NOTIFICATION_TELEGRAM_REMOVE: "notification-telegram-remove",
  NOTIFICATION_CLOSE: "notification-close",
  NOTIFICATION_SAVE: "notification-save",
  NOTIFICATION_TEST: "notification-test",

  RECURRING_ACTIVATE_OPTIONS: "recurring-activate-options",
  RECURRING_DEACTIVATE_OPTIONS: "recurring-deactivate-options",
  RECURRING_ACTIVATE: "recurring-activate",
  RECURRING_DEACTIVATE: "recurring-deactivate",
  RECURRING_ACTIVATE_NAME: "recurring-activate-name",
  RECURRING_DEACTIVATE_NAME: "recurring-deactivate-name",
  RECURRING_ACTIVATE_CONFIRM: "recurring-activate-confirm",
  RECURRING_DEACTIVATE_CONFIRM: "recurring-deactivate-confirm",
  TASK_CARD_PRIORITY: "task-card-priority",
  TASK_CARD_STATUS: "task-card-status",

  HOME_VIEWS: "home-views",
  HOME_FILTERS: "home-filters",
  HOME_CREATE_EVENT: "home-create-event",
  HOME_CREATE_TASK: "home-create-task",
  HOME_CREATE_RECURRING: "home-create-recurring",
  HOME_CREATE_REMINDER: "home-create-reminder",
  HOME_CALENDAR: "home-calendar",
  HOME_TASK_EVENT: "home-task-event",
  HOME_REMINDER_EVENT: "home-reminder-event",
  HOME_TASK_ROW: "home-task-row",
  HOME_RECURRING_ROW: "home-recurring-row",
  TASK_DETAILS: "task-details",
  TASK_FORM: "task-form",
  TASK_SAVE: "task-save",
  TASK_EDIT: "task-edit",
  TASK_DELETE: "task-delete",
  TASK_DELETE_CONFIRM: "task-delete-confirm",
  TASK_STATUS: "task-status",
  TASK_REQUIRED_NOTE: "task-required-note",
  TASK_REQUIRED_NOTE_SAVE: "task-required-note-save",
  TASK_NOTES: "task-notes",
  TASK_NOTE_ADD: "task-note-add",
  TASK_NOTE_EDIT: "task-note-edit",
  TASK_NOTE_DELETE: "task-note-delete",
  TASK_NOTE_FORM: "task-note-form",
  TASK_NOTE_SAVE: "task-note-save",
  TASK_DOCUMENTS: "task-documents",
  TASK_DOCUMENT_DOWNLOAD: "task-document-download",
  TASK_DOCUMENT_REMOVE: "task-document-remove",
  RECURRING_DETAILS: "recurring-details",
  RECURRING_FORM: "recurring-form",
  RECURRING_SAVE: "recurring-save",
  RECURRING_EDIT: "recurring-edit",
  RECURRING_DELETE: "recurring-delete",
  RECURRING_DELETE_CONFIRM: "recurring-delete-confirm",
  REMINDER_DETAILS: "reminder-details",
  REMINDER_FORM: "reminder-form",
  REMINDER_SAVE: "reminder-save",
  REMINDER_EDIT: "reminder-edit",
  REMINDER_DELETE: "reminder-delete",
  REMINDER_DELETE_CONFIRM: "reminder-delete-confirm",

  COMPENSATION_CONFIRM: "compensation-confirm",
  COMPENSATION_HISTORY: "compensation-history",
  COMPENSATION_HISTORY_DELETE: "compensation-history-delete",
  COMPENSATION_HISTORY_DELETE_CONFIRM: "compensation-history-delete-confirm",
  COMPENSATION_HISTORY_EDIT: "compensation-history-edit",
  COMPENSATION_HISTORY_FORM: "compensation-history-form",
  COMPENSATION_HISTORY_OPTIONS: "compensation-history-options",
  COMPENSATION_HISTORY_SAVE: "compensation-history-save",
  COMPENSATION_HISTORY_UPDATE_CONFIRM: "compensation-history-update-confirm",
  COMPENSATION_ROW: "compensation-row",
  COMPENSATION_SUBMIT: "compensation-submit",
  COMPENSATION_TABLE: "compensation-table",
  EMPLOYEE_CREATE: "employee-create",
  EMPLOYEE_DETAILS: "employee-details",
  EMPLOYEE_FORM: "employee-form",
  EMPLOYEE_ROW: "employee-row",
  EMPLOYEE_SAVE: "employee-save",
  HOLIDAY_CREATE: "holiday-create",
  HOLIDAY_DELETE: "holiday-delete",
  HOLIDAY_DELETE_CONFIRM: "holiday-delete-confirm",
  HOLIDAY_DELETE_CONFIRM_NAME: "holiday-delete-confirm-name",
  HOLIDAY_DETAILS: "holiday-details",
  HOLIDAY_FORM: "holiday-form",
  HOLIDAY_OPTIONS: "holiday-options",
  HOLIDAY_ROW: "holiday-row",
  HOLIDAY_SAVE: "holiday-save",
  LEAVE_APPROVE_CONFIRM: "leave-approve-confirm",
  LEAVE_DECLINE_CONFIRM: "leave-decline-confirm",
  LEAVE_DELETE_CONFIRM: "leave-delete-confirm",
  LEAVE_DETAILS: "leave-details",
  LEAVE_HISTORY_APPROVE: "leave-history-approve",
  LEAVE_HISTORY_APPROVE_OPTIONS: "leave-history-approve-options",
  LEAVE_HISTORY_CREATE: "leave-history-create",
  LEAVE_HISTORY_DECLINE: "leave-history-decline",
  LEAVE_HISTORY_DECLINE_OPTIONS: "leave-history-decline-options",
  LEAVE_HISTORY_DELETE: "leave-history-delete",
  LEAVE_HISTORY_EDIT: "leave-history-edit",
  LEAVE_HISTORY_FORM: "leave-history-form",
  LEAVE_HISTORY_OPTIONS: "leave-history-options",
  LEAVE_HISTORY_UPDATE: "leave-history-update",
  LEAVE_ROW: "leave-row",
  LEAVE_UPDATE_CONFIRM: "leave-update-confirm",
  MODAL_EDIT: "modal-edit",
  MODAL_OPTIONS: "modal-options",
} as const;

export const AssistantCompletion = {
  QUANT_ACCOUNT_CHOSEN: "quant-account-chosen",
  QUANT_INTERVAL_LOADED: "quant-interval-loaded",
  QUANT_RANGE_LOADED: "quant-range-loaded",
  QUANT_ACCOUNT_DELETED: "quant-account-deleted",
  QUANT_TRADING_PERFORMANCE_ACCOUNT_SAVED: "trading-performance-account-saved",
  QUANT_TRADING_PERFORMANCE_COMPOSITION_SAVED:
    "trading-performance-composition-saved",

  EXCHANGE_ACCOUNT_SAVED_VERIFIED: "exchange-account-saved-verified",
  EXCHANGE_ACCOUNT_REPLACEMENT_VERIFIED:
    "exchange-account-replacement-verified",
  EXCHANGE_ACCOUNT_CREATE_VERIFIED: "exchange-account-create-verified",

  INFRASTRUCTURE_SYSTEM_TASK_SAVED: "infrastructure-system-task-saved",
  INFRASTRUCTURE_SYSTEM_TASK_RUN_ACCEPTED:
    "infrastructure-system-task-run-accepted",
  INFRASTRUCTURE_SYSTEM_TASK_DISABLED: "infrastructure-system-task-disabled",
  INFRASTRUCTURE_SYSTEM_TASK_ENABLED: "infrastructure-system-task-enabled",
  INFRASTRUCTURE_SYSTEM_TASK_RETRY_ACCEPTED:
    "infrastructure-system-task-retry-accepted",
  HR_EMPLOYEE_LEAVE_SAVED: "hr-employee-leave-saved",

  HR_VENTURE_POINTS_ASSIGNMENT_DELETED: "hr-venture-points-assignment-deleted",

  HR_QUANT_DISTRIBUTION_CREATED: "hr-quant-distribution-created",
  HR_QUANT_DISTRIBUTION_UPDATED: "hr-quant-distribution-updated",
  HR_QUANT_DISTRIBUTION_DELETED: "hr-quant-distribution-deleted",
  HR_QUANT_FUND_TIER_CREATED: "hr-quant-fund-tier-created",
  HR_QUANT_FUND_TIER_UPDATED: "hr-quant-fund-tier-updated",
  HR_QUANT_FUND_TIER_DELETED: "hr-quant-fund-tier-deleted",
  HR_QUANT_FUND_TIER_DUPLICATED: "hr-quant-fund-tier-duplicated",
  HR_QUANT_PERFORMANCE_CREATED: "hr-quant-performance-created",
  HR_QUANT_PERFORMANCE_UPDATED: "hr-quant-performance-updated",
  HR_QUANT_PERFORMANCE_DELETED: "hr-quant-performance-deleted",
  HR_QUANT_POINTS_UPDATED: "hr-quant-points-updated",
  HR_CAPITAL_FORMATION_TIER_DELETED: "hr-capital-formation-tier-deleted",
  HR_CAPITAL_FORMATION_TIER_CREATED: "hr-capital-formation-tier-created",
  HR_CAPITAL_FORMATION_TIER_UPDATED: "hr-capital-formation-tier-updated",
  HR_VENTURE_DISTRIBUTION_CREATED: "hr-venture-distribution-created",
  HR_VENTURE_DISTRIBUTION_UPDATED: "hr-venture-distribution-updated",
  HR_VENTURE_DISTRIBUTION_DELETED: "hr-venture-distribution-deleted",
  HR_CAPITAL_FORMATION_DISTRIBUTION_CREATED:
    "hr-capital-formation-distribution-created",
  HR_CAPITAL_FORMATION_DISTRIBUTION_UPDATED:
    "hr-capital-formation-distribution-updated",
  HR_CAPITAL_FORMATION_DISTRIBUTION_DELETED:
    "hr-capital-formation-distribution-deleted",
  HR_CAPITAL_FORMATION_DISTRIBUTION_ADJUSTMENT_CREATED:
    "hr-capital-formation-distribution-adjustment-created",
  HR_CAPITAL_FORMATION_DISTRIBUTION_ADJUSTMENT_UPDATED:
    "hr-capital-formation-distribution-adjustment-updated",
  HR_CAPITAL_FORMATION_DISTRIBUTION_ADJUSTMENT_DELETED:
    "hr-capital-formation-distribution-adjustment-deleted",
  HR_VENTURE_PERFORMANCE_DELETED: "hr-venture-performance-deleted",
  HR_VENTURE_PERFORMANCE_CREATED: "hr-venture-performance-created",
  HR_VENTURE_PERFORMANCE_UPDATED: "hr-venture-performance-updated",
  HR_VENTURE_POINTS_CREATED: "hr-venture-points-created",
  HR_VENTURE_POINTS_UPDATED: "hr-venture-points-updated",
  HR_VENTURE_POINTS_DELETED: "hr-venture-points-deleted",
  HR_EMPLOYEE_DOCUMENT_UPLOADED: "hr-employee-document-uploaded",
  HR_QUANT_DISTRIBUTION_DOCUMENT_UPLOADED:
    "hr-quant-distribution-document-uploaded",
  HR_VENTURE_DISTRIBUTION_DOCUMENT_UPLOADED:
    "hr-venture-distribution-document-uploaded",
  HR_CAPITAL_FORMATION_DISTRIBUTION_DOCUMENT_UPLOADED:
    "hr-capital-formation-distribution-document-uploaded",

  PERMISSION_ROLE_CREATED: "permission-role-created",
  PERMISSION_ROLE_UPDATED: "permission-role-updated",
  PERMISSION_ROLE_DELETED: "permission-role-deleted",
  PERMISSION_USER_UPDATED: "permission-user-updated",
  PERMISSION_CACHE_USER_REVALIDATED: "permission-cache-user-revalidated",
  PERMISSION_CACHE_ALL_REVALIDATED: "permission-cache-all-revalidated",
  NOTIFICATION_SAVED: "notification-saved",
  NOTIFICATION_TEST_SENT: "notification-test-sent",
  NOTIFICATION_TELEGRAM_ADDED: "notification-telegram-added",
  NOTIFICATION_TELEGRAM_REFRESHED: "notification-telegram-refreshed",

  RECURRING_ACTIVATED: "recurring-activated",
  RECURRING_DEACTIVATED: "recurring-deactivated",
  TASK_PRIORITY_UPDATED: "task-priority-updated",

  TASK_CREATED: "task-created",
  TASK_UPDATED: "task-updated",
  TASK_DELETED: "task-deleted",
  TASK_NOTE_CREATED: "task-note-created",
  TASK_NOTE_UPDATED: "task-note-updated",
  TASK_NOTE_DELETED: "task-note-deleted",
  RECURRING_CREATED: "recurring-created",
  RECURRING_UPDATED: "recurring-updated",
  RECURRING_DELETED: "recurring-deleted",
  REMINDER_CREATED: "reminder-created",
  REMINDER_UPDATED: "reminder-updated",
  REMINDER_DELETED: "reminder-deleted",

  COMPENSATION_HISTORY_DELETED: "compensation-history-deleted",
  COMPENSATION_HISTORY_UPDATED: "compensation-history-updated",
  COMPENSATION_UPDATED: "compensation-updated",
  EMPLOYEE_CREATED: "employee-created",
  EMPLOYEE_UPDATED: "employee-updated",
  HOLIDAY_CREATED: "holiday-created",
  HOLIDAY_DELETED: "holiday-deleted",
  HOLIDAY_UPDATED: "holiday-updated",
  LEAVE_APPROVED: "leave-approved",
  LEAVE_CREATED: "leave-created",
  LEAVE_DECLINED: "leave-declined",
  LEAVE_DELETED: "leave-deleted",
  LEAVE_UPDATED: "leave-updated",
} as const;

export const ASSISTANT_COMPLETION_EVENT = "dashboard-assistant-completed";
